import React from 'react'
import { CFSelect, CFView, LocationSelect, MobileScreen } from 'components'
import Header from './Header'
import Hero from './Hero'
import Promotions from './Promotions'
import About from './About'
import Gallery from './Gallery'
import Contact from './Contact'
import Footer from './Footer'
import WelcomeModal from './WelcomeModal'
import { dispatch } from 'store'
import { useEffect } from 'react'

export default () => {
  useEffect(() => {
    const path = window.location.pathname

    if (path.startsWith('/coquitlam')) {
      dispatch.restaurant.setRestaurantId('u2oU5Q3iihBLH4CQgroU')
      dispatch.restaurant.setLocationId('1QhZMkcZdCJI9omNphZ3')
    }

    if (path.startsWith('/vancouver')) {
      dispatch.restaurant.setRestaurantId('hj3XWISmdUmJDvS34sEJ')
      dispatch.restaurant.setLocationId('LrYETRWvftgNfe3LQcC9')
    }
  }, [])

  return (
    <CFView row justifyCenter>
      <CFView maxWidth="1400px" w="100%">
        <Hero />
        <Promotions />
        <About />
        <Gallery />
        <Contact />
        <Footer />
      </CFView>

      <CFSelect selector={dispatch.restaurant.getWelcomeMessage}>
        <WelcomeModal />
      </CFSelect>
    </CFView>
  )
}
